import React from 'react';
import { Mail, Linkedin } from 'lucide-react';
import theme from '../../constants/theme';

export default function Contact() {
  return (
    <section id="contact" className="py-24 relative overflow-hidden" style={{ backgroundColor: theme.primary, color: theme.bg }}>
      {/* Dot pattern background */}
      <div
        className="absolute inset-0 opacity-10 pointer-events-none"
        style={{ backgroundImage: 'radial-gradient(#fbfbf5 1px, transparent 1px)', backgroundSize: '20px 20px' }}
      />

      <div className="max-w-4xl mx-auto px-6 text-center relative z-10">
        <h2 className="font-retropix text-4xl md:text-5xl mb-6">Ready to Automate?</h2>
        <p className="text-lg md:text-xl mb-10 opacity-90 max-w-2xl mx-auto">
          Whether you are a startup exploring AI integration or an enterprise ready to scale, we are here to build. Let's discuss your infrastructure.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="mailto:waleedbintahir@miraaisol.com"
            className="px-8 py-4 font-bold uppercase tracking-wider flex items-center justify-center gap-2 hover:-translate-y-1 transition-transform"
            style={{ backgroundColor: theme.bg, color: theme.primary }}
          >
            <Mail size={20} /> Email Us
          </a>
          <a
            href="https://www.linkedin.com/company/miraai-sol/"
            target="_blank"
            rel="noreferrer"
            className="px-8 py-4 font-bold uppercase tracking-wider border-2 flex items-center justify-center gap-2 hover:-translate-y-1 transition-transform"
            style={{ borderColor: theme.bg, color: theme.bg }}
          >
            <Linkedin size={20} /> LinkedIn
          </a>
        </div>
      </div>
    </section>
  );
}
